<template>
  <section>
    <div class="max-w-6xl mx-auto px-4 sm:px-6">
      <div class="py-12 md:py-20 border-t border-gray-200 lg:border-0 lg:pt-0">
        <!-- Section header -->
        <div class="max-w-3xl mx-auto text-center pb-8 md:pb-12">
          <h2 class="h2 mb-4">ご利用料金</h2>
        </div>

        <!-- Items -->
        <div
          class="max-w-sm mx-auto grid gap-8 md:grid-cols-2 lg:gap-16 items-start md:max-w-2xl lg:max-w-none"
          data-aos-id-blocks
        >
          <!-- 1st item -->
          <div class="relative flex flex-col items-center" data-aos="fade-up" data-aos-anchor="[data-aos-id-blocks]">
            <h4 class="h4 mb-2">オンライン</h4>
            <p class="h2 mb-2 text-theme-100 text-center">
              3,000円 / 30分
            </p>
            <p class="h2 text-theme-100 text-center">
              5,000円 / 60分
            </p>
          </div>

          <!-- 2nd item -->
          <div
            class="relative flex flex-col items-center"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-anchor="[data-aos-id-blocks]"
          >
            <h4 class="h4 mb-2">オフライン</h4>
            <p class="h2 mb-2 text-theme-100 text-center">
              7,000円 / 60分
            </p>
            <p class="h2 mb-2 text-theme-100 text-center">
              9,000円 / 90分
            </p>
            <p class="text-grey-600 text-center">
              +都内スペース代（1,000円~2,000円程度）
            </p>
          </div>
        </div>
        <div class="max-w-3xl mx-auto mt-12 text-center">
          <a
            class="mx-auto flex mt-12 p-4 bg-theme-100 hover:bg-theme-200 button"
            v-scroll-to="'#cta'"
            data-aos="fade-up"
            data-aos-anchor="[data-aos-id-blocks]"
            data-aos-delay="200"
          >
            <span class="block w-full font-bold text-center text-white">お申し込みはこちら</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PricePersonal",
}
</script>
